import axios from "axios";

const api = axios.create({
  baseURL: `/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let isRedirecting = false;

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;
      localStorage.clear();
      // Use replace to avoid back-button loop, no full reload
      window.location.replace("/login");
    }
    return Promise.reject(err);
  }
);

export default api;
